// "Every open task on this item assigned to exactly this name": the one rule
// for addressing tasks by assignee, shared by the SPA's query (TaskQuery's
// useAssignedToTaskQuery) and the share-assigned-tasks Lambda, so the owner's
// page and the public one cannot disagree about who "Bob" is.
//
// `assignedEmail` is free text. Unassigned is the empty string (Database
// normalizes null to '' on every write), and matching is exact and
// case-sensitive: "Bob" and "bob" are two people, because nothing in the data
// says otherwise.
//
// THE RANGE CARRIES THE SEPARATOR, and this is the reason the module exists.
// The tasksByItemIdAndAssigned GSI's sort key is the composite
// `${assignedEmail}#${priority}`. The Amplify transformer builds a partial
// `beginsWith` by joining ONLY the fields supplied with '#' and adds no
// trailing separator (graphql-transformer-common, dynamodbUtils
// `applyCompositeKeyConditionExpression`), so `beginsWith: {assignedEmail:
// 'bob'}` is `begins_with(sortKey, "bob")` and matches `bobby#1`. Appending
// the separator ourselves makes the prefix `bob#`, which only `bob`'s rows
// carry -- priority is a required column, so every row has the `#`. The input
// type is a plain String and the VTL concatenates raw, so the '#' passes
// through untouched.
//
// The filter is belt-and-braces for the one residual: an assignee whose name
// itself contains '#' (`bob#1` would sit inside `bob#`'s range). It cannot
// cause the empty-page pagination loop TaskQuery warns about, because the
// range has already narrowed the scan to (at most) that collision.

export const COMPOSITE_KEY_SEPARATOR = '#';

// True when the task (or any {assignedEmail} shaped object) names someone.
export function hasAssignee(task) {
  return typeof task?.assignedEmail === 'string' && task.assignedEmail.trim() !== '';
}

// The GSI sort-key condition for exactly `assignee`.
export function assignedRange(assignee) {
  return { beginsWith: { assignedEmail: `${assignee}${COMPOSITE_KEY_SEPARATOR}` } };
}

// The post-fetch filter that closes the '#'-in-a-name gap.
export function assignedFilter(assignee) {
  return { assignedEmail: { eq: assignee } };
}
